import { Grid, Typography } from "@mui/material";
import { TransitionGroup } from "react-transition-group";
import { EventObject } from "../../redux/Hire/candidateMeetingApi";
import InterviewComponent from "./InterviewComponent";
const InterviewBody = ({
  filteredData,
}: {
  filteredData: Array<EventObject>;
}) => {
  return (
    <Grid container direction={"column"} mb={4}>
      <Grid
        container
        item
        sx={{
          backgroundColor: "#fff",
          boxShadow: "0px 4px 8px 0px #0000000D",
          height: "54px",
        }}
        gap={1}
        px={6}
        py={2}
        mb={2}
      >
        <Grid item xs={2}>
          <Typography variant="h5">Date & Time</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h5">Job Title</Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography variant="h5">Candidate name</Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography variant="h5">Scheduled by</Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography variant="h5">Attended by</Typography>
        </Grid>
      </Grid>

      {filteredData.length > 0 ? (
        <Grid container item>
          <TransitionGroup
            style={{
              display: "flex",
              flexDirection: "column-reverse",
              flex: 1,
              gap: "16px",
            }}
          >
            {filteredData.map((interview) => (
              <InterviewComponent
                interview={interview}
                key={interview.id}
              ></InterviewComponent>
            ))}
          </TransitionGroup>
        </Grid>
      ) : (
        <Grid
          container
          item
          justifyContent={"center"}
          alignItems={"center"}
          height={"100%"}
        >
          <Typography color="#888" fontSize={18}>
            No interviews scheduled.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default InterviewBody;
